import React, { useContext, useMemo } from 'react';
import SectionHeader from 'components/SectionHeader';
import { Breadcrumb } from 'xland-ui';
import { CloudUpload, FolderPlus } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { DocumentsContext } from '../provider/DocumentsProvider';
import FolderContent from './FolderContent';
import './styles.scss';

export const getFolderName = (folder, literals) => {
  if (folder.related?.type && !folder.related.id) {
    return literals.defaultFolders[folder.related.type] || folder.name;
  }
  return folder.name;
};

function DataRoom() {
  const {
    literals,
    startup,
    breadcrumb,
    setShowCreateOrRename,
    setShowUploadPopup,
  } = useContext(DocumentsContext);

  const location = useLocation();

  const tabs = [
    { key: 'recent', name: literals.recents },
    { key: 'bookmark', name: literals.bookmarks },
    {
      key: `root.startup.${startup.id}`,
      name: literals.folders,
      actions: [
        {
          text: literals.createFolder,
          icon: FolderPlus,
          onClick: () => setShowCreateOrRename(true),
        },
        {
          className: 'btn-md-icon me-2',
          text: literals.upload,
          icon: CloudUpload,
          onClick: setShowUploadPopup,
          color: 'primary',
        },
      ],
    },
  ];

  const defaultTab = useMemo(() => {
    if (location.hash && ['#recent', '#bookmark'].includes(location.hash)) {
      return location.hash.slice(1);
    }
    return `root.startup.${startup.id}`;
  }, [location.hash, startup.id]);

  return (
    <SectionHeader tabs={tabs} defaultTab={defaultTab}>
      {tab => (
        <>
          <Breadcrumb
            routes={[
              {
                name: tabs.find(t => t.key === tab).name,
                path: tab.startsWith('root') ? '#' : undefined,
              },
              ...breadcrumb,
            ]}
            small
          />
          <FolderContent selectedFolder={{ id: tab }} />
        </>
      )}
    </SectionHeader>
  );
}

export default DataRoom;
